import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import SideBar from "./sidebar";
import About from "./about";
import UpdatePassword from "./updatePassword";
import Billing from "./billing";
import UpdatePaymentMethod from "./billing/updatePaymentMethod"
import DeleteAccount from "./billing/deleteAccount"
import ChangePlans from "./billing/changePlan"
import CancelSubscription from "./billing/cancelSubscription";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },

  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

function Profile({ history, match, close }) {
  const classes = useStyles();
  const { currentUser = {} } = useSelector((state) => ({
    currentUser: state.currentUser,
  }));
  const [showBilling, setShowBilling] = useState(false)
  useEffect(()=>{
    history.push("/about");
    if(new Date(currentUser.activationDate).getTime() < new Date().getTime()) {
      setShowBilling(true)
    }
  }, [])

  useEffect(()=>{
    if(close){
      history.push("/")
    }
  }, [close])

  return (
    <Elements stripe={stripePromise}>
      <div className={classes.root}>
        <CssBaseline />
        <SideBar showBilling={showBilling} history={history} match={match} />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Switch>
              <Route
                exact
                path={`/about`}
                component={() => <About currentUser={currentUser} />}
              />
              <Route
                exact
                path={`/update-password`}
                component={() => <UpdatePassword currentUser={currentUser} />}
              />
              {showBilling && <>
              <Route
                exact
                path={`/billing`}
                component={() => <Billing currentUser={currentUser} />}
              />
              <Route
                exact
                path={`/payment-method`}
                component={() => <UpdatePaymentMethod currentUser={currentUser} />}
              />
              <Route
                exact
                path={`/delete`}
                component={() => <DeleteAccount currentUser={currentUser} />}
              />
              <Route
                exact
                path={`/cancel`}
                component={() => <CancelSubscription currentUser={currentUser} />}
              />
              <Route
                exact
                path={`/plan`}
                component={() => <ChangePlans currentUser={currentUser} />}
              />
              </>
              }
              {!close &&  <Route render={() => <Redirect to={`/about`} />} />}
            </Switch>
          </Container>
        </main>
      </div>
    </Elements>
  );
}

export default withRouter(Profile);
